import { Table } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'
import { installationRowClass } from '~/features/installations/constants'
import { isRetired } from '~/features/installations/service'
import { CompatibilityBadge } from '~/features/installations/components/CompatibilityBadge'
import { CellText } from '~/components/CellText'
import { InstallationIdentityCells, InstallationIdentityHeaders } from './InstallationIdentityCells'

type Installation = TRPCOutputs['ops']['stationInstallations']['list'][number]

const COLUMNS = [
  { label: 'Meter maker', value: (row: Installation) => row.meter_maker },
  { label: 'Meter model', value: (row: Installation) => row.meter_model },
  { label: 'Pulse weight', value: (row: Installation) => row.pulse_weight },
  { label: 'Profile', value: (row: Installation) => row.installation_profile },
  { label: 'Logger maker', value: (row: Installation) => row.logger_maker },
  { label: 'Serial', value: (row: Installation) => row.logger_serial_number, mono: true }
]

interface InstallationHardwareTableProps {
  installations: Installation[]
  onRowClick: (installationId: number) => void
}

export const InstallationHardwareTable = ({ installations, onRowClick }: InstallationHardwareTableProps) => (
  <Table.Root variant="surface">
    <Table.Header>
      <Table.Row>
        <InstallationIdentityHeaders />
        <Table.ColumnHeaderCell>Compatibility</Table.ColumnHeaderCell>
        {COLUMNS.map((column) => (
          <Table.ColumnHeaderCell key={column.label}>{column.label}</Table.ColumnHeaderCell>
        ))}
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {installations.map((row) => (
        <Table.Row
          key={row.installation_id}
          onClick={() => onRowClick(row.installation_id)}
          className={installationRowClass({ isStalled: row.current_stall !== null, isRetired: isRetired(row) })}
        >
          <InstallationIdentityCells installation={row} />
          <Table.Cell>
            <CompatibilityBadge status={row.compatibility_status} />
          </Table.Cell>
          {COLUMNS.map((column) => (
            <Table.Cell key={column.label}>
              <CellText value={column.value(row)} mono={column.mono} />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  </Table.Root>
)
